import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from "@emotion/styled";
import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import { css} from "@emotion/core";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


const pricing = [
    {
      id : "subscription-3-months-button",
      title1: "WW Subscription:",
      title2: "3 months",
      perks: [
        {option:true, divider:true},
        {option:true, divider:true},
        {option:true},
       ],
      isprice: true,
      price: "IDR 145K",
      buttonText: "Sign up now!",
      buttonLink: "https://forms.gle/HD6bwbarYqyEN6hf6",
      isSubscription: true,
      isRecommended: true,
    },
    {
      id : "subscription-1-month-button",
      title1: "WW Subscription:",
      title2: "1 months",
      perks: [
        {option:true, divider:true},
        {option:false, divider:true, text:"Only access to 10 past recordings"},
        {option:false, text:"No"},
       ],
      isprice: true,
      price:  "IDR 350K",
      buttonText: "Sign up now!",
      buttonLink: "https://forms.gle/HD6bwbarYqyEN6hf6",
      isSubscription: true,
      isRecommended: false,
    },
    {
      id: "1on1-button",
      title1: "1:1",
      title2: "Mentorship",
      perks: [
        {option:false, divider:true, text:"No, pay per session"},
        {option:false, divider:true, text:"No"},
        {option:false, text:"No"},
       ],
      isprice: false,
      buttonText: "Learn more",
      buttonLink: "/one-on-one-mentorship/",
      isSubscription: false,
      isRecommended: false,
    },
  ]

  const SectionBackground = styled.div`
  background-color : ${props => props.theme.colors.white};
  color : ${props => props.theme.colors.gray_dark};
  min-height:500px;
  margin-bottom: 60px;
  margin-top: 60px;
  @media (max-width: 991px) {
    margin-bottom: 25px;
  }
`

const SectionContainer = styled(Container)`
    display: flex;
    flex-wrap: wrap;
`

const SectionTitle = styled.div`
  color : ${props => props.theme.colors.gray_dark};
  margin-top:30px;
  margin-bottom:35px;
  max-width:900px;
  text-align:left;
  font: 58px/62px Abril Fatface;
  @media(max-width:991px){
    margin-top:80px;
    margin-bottom:30px;
  }
  @media(max-width:767px){
    margin-top:20px;
    font: 2.5rem/3rem Abril Fatface;
  }
  @media(max-width:320px){
    font: 2rem/2.5rem Abril Fatface;
  }
`
const Line = styled.hr`
  display:  ${props => props.displayLine};
  border-top: 2px dotted ${props=>props.theme.colors.gray_dark};
  @media(max-width:990px){
    width:100%
  }
  @media(min-width:991px){
    width:${props=>props.isSubscription? "100%" : "150%"};
    margin-left:${props=>props.isSubscription? "0px" : "-45px"};
  }
`

const FeatureText= styled(Card)`
    height: 482px;
    position: relative;
    border: 0px;
    @media(min-width:768px){
        width: 250px};
        margin-top:55px;
    }
    @media(min-width:1200px){
      width: 280px};
      margin-top:55px;
  }
`

const FeatureItem = styled(Card.Text)`
    font: 16px/22px Roboto;
    margin-bottom:15px;
    text-align:left;
    @media(max-width:767px){
      font: 12px/16px Roboto;
    }
`

const PricingMentorshipCard = styled(Card)`
    position: relative;
    box-shadow: ${props=>props.isRecommended? "0px 1px 3px" + props.theme.colors.gray_shadow_card : "0px"};
    @media(max-width:767px){
       height: ${props=>props.isSubscription?`482px`:`360px`};
        width: 96%;
        margin-right: auto;
        margin-left: auto;
        margin-top: 15px;
        &:hover, &:focus, &.focus, &:active, &.active  {
          margin-top:10px;
        }
        border: ${props=>props.isRecommended? "4px solid "+ props.theme.colors.primary_violet
        :"4px solid " + props.theme.colors.gray};
    }
    @media(min-width:768px){
        height: ${props=>props.isSubscription?`482px`:`360px`};
        width: 96%;
        margin-right: auto;
        margin-left: auto;
        margin-top:55px;
        &:hover, &:focus, &.focus, &:active, &.active  {
          margin-top:50px;
        }
        border: ${props=>props.isRecommended? "4px solid "+ props.theme.colors.primary_violet
        :"4px solid " + props.theme.colors.gray};
    }
    @media(min-width:991px){
      height: 482px;
      width: ${props=>!props.isSubscription?`180px`:`258px`};
      margin-top:55px;
      margin-left: 30px;
      &:hover, &:focus, &.focus, &:active, &.active  {
        margin-top:50px;
      }
      border: ${props=>props.isRecommended? "4px solid "+ props.theme.colors.primary_violet
      :"4px solid " + props.theme.colors.white};
    }
    @media(min-width:1200px){
      height: 482px;
      width: ${props=>!props.isSubscription?`190px`:`278px`};
      margin-top:55px;
      margin-left: 30px;
      &:hover, &:focus, &.focus, &:active, &.active  {
        margin-top:50px;
      }
      border: ${props=>props.isRecommended? "4px solid "+ props.theme.colors.primary_violet
      :"4px solid " + props.theme.colors.white};
    }
`
const CardTitle = styled(Card.Title)`
  margin-bottom:30px;
  margin-top:18px;
  text-align:center;
  color: ${props=>props.isRecommended? props.theme.colors.primary_violet : props.theme.colors.gray_dark};
  @media(max-width:767px){
    font: normal 16px/28px Roboto;
  }
  @media(min-width:768px){
    font: normal 24px/32px Roboto;
  }
  @media(min-width:1200px){
    font: normal 28px/32px Roboto;
  }
`

const CardText = styled(Card.Text)`
    font: 16px/22px Roboto;
    margin-bottom:20px;
    text-align:center;
    justify-content: center;
    height:32px;
    @media(max-width:767px){
      font: 12px/22px Roboto;
    }
`

const PriceText = styled.div`
    color: ${props=>props.theme.colors.secondary_green10};
    font: 16px/32px Roboto;
    width: fit-content;
    position: absolute;
    margin-top: 10px;
    bottom: 115px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    @media(max-width:767px){
      font: 16px/16px Roboto;
    }
`

const ButtonContainer = styled.div`
    position: absolute;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    width: fit-content;
    @media(max-width:767px){
        bottom: 0.2px;
    }
    @media(min-width:768px){
        bottom: 40px;
    }
`

const ButtonFill = styled(Button)`
    height: 60px;
    color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .normal.color} !important;
    background-color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .normal.background_color} !important;
    border-color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .normal.border_color} !important;
    font: 22px/22px Roboto;
    transition: 0.25s ease-out;
    padding: 0px 20px 0px 20px;
    &:hover {
    color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .hovered.color} !important;
    background-color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .hovered.background_color} !important;
    border-color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .hovered.border_color} !important;
    box-shadow: 0px 3px 20px ${props => props.theme.colors.gray_shadow} !important;
    @media(min-width:1199px){
        margin-top:-3px;
        margin-bottom:3px;
    }
    }
    &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .pressed.color} !important;
    background-color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .pressed.background_color} !important;
    border-color: ${props => props.theme
        .buttons[props.isRecommended? "primary_button_violet" : "secondary_big_button_violet"]
        .pressed.border_color} !important;
    box-shadow: none !important;
    @media(min-width:1199px){
        margin-top:-3px;
        margin-bottom:3px;
    }
    }
    @media(max-width:767px){
      width:100%;
      margin-bottom:20px;
      font: 16px/22px Roboto;
    }
`

const FACheck = styled(FontAwesomeIcon)`
  font-size:2rem;
  color: ${props => props.theme.colors.secondary_green10};
  @media(max-width:767px){
    font-size:1.5rem;
  }
`
const RecommendedButton = styled(Button)`
    width: 180px;
    height: 32px;
    border-radius: 25px;
    background: linear-gradient(90deg, ${props=>props.theme.colors.secondary_green_gradient_light} 0%, 
        ${props=>props.theme.colors.secondary_green_gradient_dark} 100%)!important;
    font: normal normal bold 14px/14px Roboto;
    text-align: right;
    position: absolute;
    padding-right:20px;
    top: 25%;
    left: 48%;
`

const CrownCircle = styled(Button)`
    position: absolute;
    left: 0;
    top: 0;
    width: 72px;
    height: 72px;
    border-radius: 72px;
    color:white !important;
    background-color:white !important;
    box-shadow: 0px 1px 10px #00000029;
`

const CrownImg = styled.img`
    width: 42px;
    object-fit: contain;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

const RecommendedContainer = styled(Container)`
    position: absolute;
    top: -37px;
    @media(max-width:767px){
        left: 10%;
    }
    @media(max-width:991px){
      left: 10%;
  }
`

function RecommendedCircle(isRecommended){
    if(isRecommended){
        return (
            <RecommendedContainer
            >
                <div css={css`position:relative;width:72px;height:72px;`}>
                    <RecommendedButton 
                    >
                        RECOMMENDED!
                    </RecommendedButton>
                    <CrownCircle>
                    <CrownImg alt="WomenWorks - crown" src="/page-sign-up-for-mentorship-section8-img1.png"/>
                    </CrownCircle>
                </div>
            </RecommendedContainer>
        )
    }
}


export default function SubscriptionSection1(props) {
  return (    
    <SectionBackground css={css`
    @media(max-width:991px) {
      display: none;
    }`}>
    <Container>
    <SectionContainer>
          <SectionTitle>
            Enjoy WomenWorks anytime through subscription
          </SectionTitle>
      <Row css={css`justify-content: center;`}>
        <Col css={css`
                  @media(max-width:991px) {
                    display: none;
                  }`}>
          <FeatureText>
          <Card.Body css={css`margin-top:110px`}>
          <FeatureItem><b>Unlimited access to 1:1 mentorship</b> sessions</FeatureItem>
          <FeatureItem><b>Unlimited access to ALL WomenWorks Masterclasses</b> (live and past recordings)</FeatureItem>
          <FeatureItem><b>Unlimited, personalized guidance for big career leaps.</b> Perfect for Master’s degree application, newly promoted managers, and intensive job seekers.</FeatureItem>
          </Card.Body>
          </FeatureText>
        </Col>
        {pricing.map((item, i) => 
            <Row css={css`justify-content: center;`}>
            <Col xs="12" css={css`
            padding: 0 0 0 0;
            @media(max-width:767px){
                padding-top: ${item.isRecommended? '15px':'0px'};
            }
            `}>
              <PricingMentorshipCard isSubscription={item.isSubscription}
              isRecommended={item.isRecommended}>

                  {RecommendedCircle(item.isRecommended)}

                  <Card.Body>
                      {item.isSubscription?
                      <CardTitle isRecommended={item.isRecommended}
                      >{item.title1}<br/><b>{item.title2}</b>
                      </CardTitle>
                      :
                      <CardTitle isRecommended={item.isRecommended}
                      >{item.title1}<br/>{item.title2}
                      </CardTitle>
                      }
                      <Row>
                      <Col>
                        {item.perks.map((perk)=>
                        (<div css={css`justify-content: center;, text-align:center`}>{perk.option?
                          <div>
                            <Row css={css`justify-content: center;, text-align:center`}>
                              <CardText xs="6"><FACheck icon={faCheck} /></CardText>
                            </Row>
                            {
                              perk.divider?
                              <Line displayLine={props.DisplayLine} isSubscription={item.isSubscription}></Line>
                              :
                              <Row></Row>
                            }
                            </div>
                          :<div>
                            <Row css={css`justify-content: center;, text-align:center`}>
                            <CardText xs="6">{perk.text}</CardText>
                            </Row>
                            {
                              perk.divider?
                              <Line displayLine={props.DisplayLine} isSubscription={item.isSubscription}></Line>
                              :
                              <Row></Row>
                            }
                            </div>}</div>)

                        )}
                      </Col>
                      </Row>
                      <Row>
                          {item.isprice?
                            <div><PriceText>{item.price} per month</PriceText></div>
                            :
                            <div></div>
                          }
                          <ButtonContainer>
                          {
                            item.isSubscription?
                              <OutboundLink target="_blank" rel="noreferrer" href={item.buttonLink} id={item.id}>
                              <ButtonFill isRecommended={item.isRecommended}>
                                {item.buttonText}
                              </ButtonFill>
                              </OutboundLink>
                            :
                              <OutboundLink href={item.buttonLink}>
                              <ButtonFill isRecommended={item.isRecommended}>
                                {item.buttonText}
                              </ButtonFill>
                              </OutboundLink>
                          }
                        </ButtonContainer>
                      </Row>
                  </Card.Body>
              </PricingMentorshipCard>
            </Col>
            </Row>
        )}
      </Row>
    </SectionContainer>
    </Container>
    </SectionBackground>  
  )
}